import { createModel } from "hox";
import { message } from "antd";
import { IMdSettingDetail, IMdSettingFields, settingService } from "./settingService";
import React, { useEffect, useState } from "react";
import { defaultMdCmParam } from "../../../utils/constants";
import { filterTree, trasDsToTreeData } from "../dict/dictModel";
import { OptModelTypeEnum } from "../../../components/YHDict/Types";

export enum SettingOptModeEnum {
    ADD,
    EDIT,
}

export const useSettingModel = createModel(function () {

    const [optMode, setOptMode] = useState(SettingOptModeEnum.EDIT)
    const initSearchParam: IMdSettingFields = {};
    const initDataSource: IMdSettingDetail[] = [];

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdSettingFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdSettingDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IMdSettingFields>();

    const [selectParentData, setSelectParentData] = useState<IMdSettingFields>()
    const [optModelType, setOptModelType] = useState<OptModelTypeEnum>(OptModelTypeEnum.DETAIL)


    const getTreeData = () => {
        let treeData = trasDsToTreeData(dataSource, "code", "note");
        return treeData;
    }

    const updateSearchParam = (updateParam: IMdSettingFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData({});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
    const loadData = async (searchValue: IMdSettingFields = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
        }
        let { retData } = await settingService.find(searchParams);
        retData ? message.success("数据加载成功!") : message.error("数据加载失败!");
        setDataSource(retData);
        return retData;
    }
    const syncData = async () => {
        let ret = await settingService.sync(searchParam);
        ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败!");
        ret && await loadData();
    }


    return {
        /***field***/
        selectedRowKeys,
        searchParam,
        dataSource,
        selectedData,
        optMode,
        selectParentData,
        optModelType,

        /***method***/
        setOptMode,
        getTreeData,
        setSelectedRowKeys,
        setDataSource,
        resetSearchParam,
        updateSearchParam,
        loadData,
        syncData,
        setSelectedData,

        setSelectParentData,
        setOptModelType,
    }
});